import { buildXAxis } from './xAxis'

export default function XAxisLabels({ data, usableWidth, xScale, left, right, y, theme }) {
  const axis = buildXAxis(data, usableWidth)
  const common = { y, fill: theme.muted, fontSize: '9', fontFamily: 'DM Sans, sans-serif' }
  return (
    <>
      {axis.ticks.map(t => (
        <text key={t.i} x={xScale(t.i)} textAnchor="middle" {...common}>{t.text}</text>
      ))}
      {axis.leftMonth && <text x={left - 10} textAnchor="end" fontWeight="700" {...common}>{axis.leftMonth}</text>}
      {axis.rightMonth && <text x={right + 10} textAnchor="start" fontWeight="700" {...common}>{axis.rightMonth}</text>}
    </>
  )
}
